module.exports = {
      id: "paywalliconbenefitfour-usage",
      viewBox: "0 0 29.38 29.38",
      url: "/" + "sprite-84df178c245af8be09420a4d0455d997.svg#paywalliconbenefitfour",
      toString: function () {
        return this.url;
      }
    }